import axios from "axios";
import { API } from "../config";

const path = "/pendencias/relatorio";
const pathServico = "/servico-acolhimento";
const pathCrianca = "/criancas";

class RelatorioService {
  getRelatorioPendenciaServico(access_token, filters) {
    const {
      municipioId,
      promocaoId,
      tipoRelatorio,
      servicoAtendimentoId,
      dataReferencia,
      pageSize,
      page,
      sortField,
      sortType,
    } = filters;

    return axios.get(API + pathServico + path, {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
      params: {
        municipioId: municipioId !== "" ? municipioId : undefined,
        promocaoId: promocaoId !== "" ? promocaoId : undefined,
        tipoRelatorio: tipoRelatorio !== "" ? tipoRelatorio : undefined,
        servicoAtendimentoId:
          servicoAtendimentoId !== "" ? servicoAtendimentoId : undefined,
        dataReferencia: dataReferencia !== "" ? dataReferencia : undefined,
        pageSize: pageSize !== "" ? pageSize : 10,
        page: page !== "" ? page : 0,
        sortField: sortField ? sortField : undefined,
        sortType: sortType ? sortType : undefined,
      },
    });
  }
  getRelatorioPendenciaCrianca(access_token, filters) {
    const {
      municipioId,
      promocaoId,
      tipoRelatorio,
      servicoAtendimentoId,
      dataReferencia,
      pageSize,
      page,
      sortField,
      sortType,
    } = filters;

    return axios.get(API + pathCrianca + path, {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
      params: {
        municipioId: municipioId !== "" ? municipioId : undefined,
        promocaoId: promocaoId !== "" ? promocaoId : undefined,
        tipoRelatorio: tipoRelatorio !== "" ? tipoRelatorio : undefined,
        servicoAtendimentoId:
          servicoAtendimentoId !== "" ? servicoAtendimentoId : undefined,
        dataReferencia: dataReferencia !== "" ? dataReferencia : undefined,
        pageSize: pageSize !== "" ? pageSize : 10,
        page: page !== "" ? page : 0,
        sortField: sortField ? sortField : undefined,
        sortType: sortType ? sortType : undefined,
      },
    });
  }

  getRelatorioCrianca(access_token, filters) {
    const {
      universoConsulta,
      idsServicosAcolhimento,
      idTipoTransferencia,
      dataInicio,
      dataFim,
      idsMotivosEntrada,
      idTipo,
      idJustificativas,
      tipoPeriodo,
      entradasPorTransferencias,
      saidaTransferencia,
      maioresDezoito,
      pageSize,
      page,
      sortField,
      sortType,
    } = filters;

    return axios.get(API + "/relatorios-criancas-adolescentes", {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
      params: {
        universoConsulta:
          universoConsulta !== "" ? universoConsulta : undefined,
        idTipoTransferencia:
          idTipoTransferencia !== "" ? idTipoTransferencia : undefined,
        idsServicosAcolhimento:
          idsServicosAcolhimento !== "" ? idsServicosAcolhimento : undefined,
        dataInicio: dataInicio !== "" ? dataInicio : undefined,
        dataFim: dataFim !== "" ? dataFim : undefined,
        idsMotivosEntrada:
          idsMotivosEntrada !== "" ? idsMotivosEntrada : undefined,
        idTipo: idTipo !== "" ? idTipo : undefined,
        idJustificativas:
          idJustificativas !== "" ? idJustificativas : undefined,
        tipoPeriodo: tipoPeriodo !== "" ? tipoPeriodo : undefined,
        entradasPorTransferencias:
          entradasPorTransferencias !== ""
            ? entradasPorTransferencias
            : undefined,
        saidaTransferencia:
          saidaTransferencia !== "" ? saidaTransferencia : undefined,
        maioresDezoito: maioresDezoito !== "" ? maioresDezoito : undefined,
        pageSize: pageSize !== "" ? pageSize : 10,
        page: page !== "" ? page : 0,
        sortField: sortField ? sortField : undefined,
        sortType: sortType ? sortType : undefined,
      },
      paramsSerializer: (params) => {
        const searchParams = new URLSearchParams();
        Object.entries(params).forEach(([key, value]) => {
          if (Array.isArray(value)) {
            value.forEach((v) => searchParams.append(key, v));
          } else if (value !== undefined && value !== null) {
            searchParams.append(key, value);
          }
        });
        return searchParams.toString();
      },
    });
  }

  getRelatorioServicoAcolhimento(filters) {
    return axios.post(API + "/relatorios-servicos-acolhimentos", filters);
  }

  getRelatorioCriancaGeral(filters) {
    return axios.post(
      API + "/relatorios-criancas-adolescentes-gestor",
      filters,
    );
  }

  getExecelListaRelatorio(filters) {
    return axios.post(API + `/fila-processamento/gerar`, filters);
  }

  getFilaProcessamentoAtivos() {
    return axios.get(API + `/fila-processamento/processamentos/ativos`);
  }

  getExecelListaRelatorioCrianca(filters) {
    return axios.post(
      API + `/fila-processamento/gerar/relatorio-crianca-adolescentes`,
      filters,
    );
  }

  getExecelListaRelatorioServicoAcolhimento(filters) {
    return axios.post(
      API + `/fila-processamento/gerar/relatorios-servicos-acolhimentos`,
      filters,
    );
  }

  getExecelListaRelatorioCriancaAdolescenteGeral(filters) {
    return axios.post(
      API + `/fila-processamento/gerar/relatorio-crianca-adolescentes-gestor`,
      filters,
    );
  }

  getFilaProcessamento(access_token, filters) {
    const {
      nomeResponsavel,
      statusRelatorio,
      tipoRelatorio,
      pageSize,
      page,
      sortField,
      sortType,
    } = filters;

    return axios.get(API + `/fila-processamento/usuario`, {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
      params: {
        nomeResponsavel: nomeResponsavel !== "" ? nomeResponsavel : undefined,
        statusRelatorio: statusRelatorio !== "" ? statusRelatorio : undefined,
        tipoRelatorio: tipoRelatorio !== "" ? tipoRelatorio : undefined,
        pageSize: pageSize !== "" ? pageSize : 10,
        page: page !== "" ? page : 0,
        sortField: sortField ? sortField : undefined,
        sortType: sortType ? sortType : undefined,
      },
    });
  }

  getFilaProcessamentoDownload(idFila) {
    return axios.get(API + `/fila-processamento/${idFila}/download`, {
      responseType: "blob",
    });
  }

  getFilaProcessamentoDelete(idFila) {
    return axios.delete(API + `/fila-processamento/${idFila}/cancelar`);
  }

  deleteAllFilaProcessamento(ids) {
    const query = ids.map((id) => `ids=${id}`).join("&");

    return axios.delete(`${API}/fila-processamento/cancelar-lote?${query}`);
  }
}

const instanceRelatorio = new RelatorioService();
export default instanceRelatorio;
